import {InitRecordSchema,AwardData} from "slotworks/integration/revolver/schema/init-record-schema";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import {RecordBuilder} from "slotworks/server/builders/record-builder";
import CampaignsModel from "slotworks/integration/revolver/model/campaigns-model";
import {Freespins} from "slotworks/integration/revolver/model/campaigns-model";
import BetModel from "slotworks/model/bets/bet-model";
import SlotDefinition from "slotworks/model/slot-definition";
import * as moment from 'moment';
import SettingsModel from "slotworks/model/settings/settings-model";

class CampaignsRecordBuilder implements RecordBuilder {

    public filter(data: any): boolean {
        let initRecord: InitRecordSchema;

        if (data && data.data) {
            initRecord = data.data as InitRecordSchema;
        }

        return initRecord && initRecord.CAMPAIGNS !== undefined;
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        let initRecord: InitRecordSchema;

        if (data && data.data) {
            initRecord = data.data as InitRecordSchema;
        }

        let freespin = initRecord.CAMPAIGNS.FREESPIN;
        if(freespin && freespin.awardData) {
            
            let awardData = typeof freespin.awardData === "string" ? JSON.parse(freespin.awardData) as AwardData : freespin.awardData as AwardData;

            const betLevel = awardData.bet_level;
            const coinLevel = awardData.coin_level;

            if (SlotDefinition && SlotDefinition.stakes.length >= betLevel && SlotDefinition.coinSizes.length >= coinLevel) {

                CampaignsModel.freespins = new Freespins();
                moment.locale(SettingsModel.language);

                let useBefore = moment(freespin.useBefore).format('lll') as string;
                CampaignsModel.freespins = {
                    ...CampaignsModel.freespins,
                    isComplete: awardData.count === 0,
                    total: awardData.total,
                    remaining: awardData.count,
                    betLevel: awardData.bet_level,
                    coinLevel: awardData.coin_level,
                    awardId: freespin.awardId,
                    awardType: freespin.awardType,
                    campaignId: freespin.campaignId,
                    useBefore: useBefore,
                    type: freespin.type
                };

                if (freespin.currentOutCome) {
                    try {
                        CampaignsModel.freespins.totalWin = freespin.currentOutCome.totalFreeWins;
                    }catch(e) {

                    }

                }

                BetModel.setCoinSize(SlotDefinition.coinSizes[CampaignsModel.freespins.coinLevel - 1]);
                BetModel.setBetPerLine(SlotDefinition.stakes[CampaignsModel.freespins.betLevel - 1]);
            }            
        }

        const records: Record[] = [];

        return records;
    }
}

export default new CampaignsRecordBuilder();



// WEBPACK FOOTER //
// ./~/slotworks/integration/revolver/builders/records/campaigns-record-builder.ts